import type {
  JobOperation,
} from '../types'

export default ({
  operations: [],
}: {
  operations: Array<JobOperation>,
})
